import { type FC } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import {
  checkAgent,
  checkAffiliateDropdown,
  checkAffiliate
} from '../PermissionsWrappers/permissionChecks';
import FilterContainer from '../Filters/FilterContainer';
import { type IPageListElementType } from '../../Utilities/types/pageContainerTypes';

interface IStoreState {
  pageReducer: {
    selectedPage: string;
  };
}

interface IPageFiltersProps {
  selectedPageListItem: IPageListElementType;
}

export const PageFilters: FC<IPageFiltersProps> = ({
  selectedPageListItem
}) => {
  const selectedPage = useSelector((state: IStoreState) => {
    return state.pageReducer.selectedPage;
  });

  const { filters } = selectedPageListItem;

  if (!filters) {
    return null;
  }

  if (checkAffiliateDropdown() && filters.affiliateID) {
    delete filters.affiliateID;
  }
  if (checkAgent() && filters.agentFilter) {
    delete filters.agentFilter;
  }
  if (checkAffiliate() && filters.trafficSource) {
    delete filters.trafficSource;
  }

  return (
    <Grid container justifyContent="flex-end" alignItems="center">
      <FilterContainer
        key={selectedPage}
        filterList={filters}
        page={selectedPage}
      />
    </Grid>
  );
};
